import {
    SETTINGS_PAYMENT_ANONYMOUS_ACQUIRING_SLUG,
    SETTINGS_PAYMENT_ATOL_TAX_SYSTEM_SLUG,
    SETTINGS_PAYMENT_AUTHORIZED_ACQUIRING_SLUG,
    SETTINGS_PAYMENT_CLOUD_KASSIR_TAX_SYSTEM_SLUG,
    SETTINGS_PAYMENT_CLOUD_PAYMENTS_PRIVATE_KEY_SLUG,
    SETTINGS_PAYMENT_CLOUD_PAYMENTS_PUBLIC_KEY_SLUG,
    SETTINGS_PAYMENT_ENABLE_SELF_PICKUP_ONLINE_PAYMENT_SLUG,
    SETTINGS_PAYMENT_ENABLE_SELF_PICKUP_POSTPAYMENT_SLUG,
    SETTINGS_PAYMENT_OWN_CASHIER_SELECTED_SLUG,
    SETTINGS_PAYMENT_OZON_PAY_ACCESS_KEY_SLUG,
    SETTINGS_PAYMENT_OZON_PAY_SECRET_KEY_SLUG,
    SETTINGS_PAYMENT_YANDEX_PAY_MERCHANT_ID_SLUG,
    SETTINGS_PAYMENT_YANDEX_PAY_TOKEN_SLUG,
} from '../../constants';
import { useSettingsFactory } from './useSettingsFactory';

export const useSettingsPayment = () =>
    useSettingsFactory({
        ozonPayAccessKey: { path: SETTINGS_PAYMENT_OZON_PAY_ACCESS_KEY_SLUG },
        ozonPaySecretKey: { path: SETTINGS_PAYMENT_OZON_PAY_SECRET_KEY_SLUG },
        cloudPaymentsPublicKey: { path: SETTINGS_PAYMENT_CLOUD_PAYMENTS_PUBLIC_KEY_SLUG },
        cloudPaymentsPrivateKey: { path: SETTINGS_PAYMENT_CLOUD_PAYMENTS_PRIVATE_KEY_SLUG },
        yandexPayMerchantId: { path: SETTINGS_PAYMENT_YANDEX_PAY_MERCHANT_ID_SLUG },
        yandexPayToken: { path: SETTINGS_PAYMENT_YANDEX_PAY_TOKEN_SLUG },
        authorizedAcquiring: { path: SETTINGS_PAYMENT_AUTHORIZED_ACQUIRING_SLUG },
        anonymousAcquiring: { path: SETTINGS_PAYMENT_ANONYMOUS_ACQUIRING_SLUG },
        atolTaxSystem: { path: SETTINGS_PAYMENT_ATOL_TAX_SYSTEM_SLUG },
        cloudKassirTaxSystem: { path: SETTINGS_PAYMENT_CLOUD_KASSIR_TAX_SYSTEM_SLUG },
        enableSelfPickupPostPayment: { path: SETTINGS_PAYMENT_ENABLE_SELF_PICKUP_POSTPAYMENT_SLUG },
        enableSelfPickupOnlinePayment: { path: SETTINGS_PAYMENT_ENABLE_SELF_PICKUP_ONLINE_PAYMENT_SLUG },
        ownCashierSelected: { path: SETTINGS_PAYMENT_OWN_CASHIER_SELECTED_SLUG },
    });

export type SettingsPaymentType = ReturnType<typeof useSettingsPayment>;
